import {connect} from "react-redux";
import { setDialogCustomizeShow,setBackButtonShow } from "../../redux/actions/actions.js";
import { useNavigate } from "react-router-dom";
import React from "react";

const Main_Content_Header = (props) => {
    const navigate = useNavigate();
    const showCustomize = () => {
        props.onSetDialogCustomizeShow("show");
    }
    const goBack = () => {
        navigate(-1);
        props.onSetBackButtonShow("hide");
    }
    return(
        <header className={`main_content_header main_content_section main_content_section_${props.color_background}`}>
            <ul className="main_content_header_ul">
                <li className="main_content_header_li main_content_header_li_text">
                    <div onClick={goBack} className={`button_more_div background_change_hover_${props.color_background} back_button_${props.back_button_show}`}>
                        <i className="fa-solid fa-arrow-left"></i>
                    </div>
                    {props.title}
                </li>
                <li onClick={showCustomize} title="Customize your view" className={`main_content_header_li main_content_header_li_button background_change_hover background_change_hover_${props.color_background}`}>
                    <i className="fa-regular fa-star"></i>
                </li>
            </ul>
        </header>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        title: state.getSectionTitle.title,
        dialog_customize_show: state.setDialogCustomizeShow.dialog_customize_show,
        back_button_show: state.setBackButtonShow.back_button_show
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetDialogCustomizeShow: (text) => dispatch(setDialogCustomizeShow(text)),
        onSetBackButtonShow: (text) => dispatch(setBackButtonShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Main_Content_Header);